export enum VenueTransactionType {
  INVOICE = 'invoice',
  CREDIT_NOTE = 'credit_note',
}
